import {
  ApplicationConfig,
  LOCALE_ID,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimations } from '@angular/platform-browser/animations';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import eslocale from '@angular/common/locales/es-AR';
import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CredentialsInterceptor } from './core/services/shared/interceptors/credentials.interceptor';
import { ErrorHandlerService } from '@shared-services/handlers/error-handler.service';
import { HttpErrorsInterceptor } from '@shared-services/interceptors/http-errors.interceptor';
import { SubscriptionRequiredInterceptor } from '@shared-services/interceptors/subscription-required.interceptor';
import { PermissionsInterceptor } from '@shared-services/interceptors/permissions.interceptor';
import { loaderInterceptor } from './core/interceptors/loader.interceptor';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

registerLocaleData(eslocale);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({ canceledNavigationResolution: 'computed' }),
    ),
    provideHttpClient(
      withInterceptors([loaderInterceptor]),
      withInterceptorsFromDi(),
    ),
    provideAnimations(),
    provideNgxMask(),
    importProvidersFrom(MatSnackBarModule, MatDialogModule),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CredentialsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SubscriptionRequiredInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PermissionsInterceptor,
      multi: true,
    },
    ErrorHandlerService,
  ],
};
